import { gql } from '@apollo/client';

export const FILTERED_PROMOTIONS = gql`
  query FilteredPromotions($input: SearchData!) {
    promotions: filteredSchoolPromotionDatas(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          circuit {
            id
            name
          }
          district {
            id
            name
          }
          emisNumber
          grade {
            id
            value
          }
          gradeAverage
          numberEnrolled
          numberPassed
          numberWrote
          percentagePassed
          promotionStatus {
            id
            name
          }
          term
          year
          institution {
            id
            name
          }
        }
      }
    }
  }
`;
